export default "__VITE_ASSET__2395e23d__"